import type { ReactNode } from 'react';

export const symbol_mobile_camera: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M260-260v160-760 600Zm240-469q9-9 9-21t-9-21q-9-9-21-9t-21 9q-9 9-9 21t9 21q9 9 21 9t21-9ZM260-40q-24.75 0-42.37-17.63Q200-75.25 200-100v-760q0-24 18-42t42-18h438q24.75 0 42.38 17.62Q758-884.75 758-860v130q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-130H260v760h438v-130q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v130q0 24.75-17.62 42.37Q722.75-40 698-40H260Zm320-280q-25 0-42.5-17.5T520-380v-160q0-25 17.5-42.5T580-600h40l31-31q5-5 10.22-7 5.21-2 10.78-2h56q5.57 0 10.78 2 5.22 2 10.22 7l31 31h40q25 0 42.5 17.5T880-540v160q0 25-17.5 42.5T820-320H580Zm169.5-90.5Q770-431 770-460t-20.5-49.5Q729-530 700-530t-49.5 20.5Q630-489 630-460t20.5 49.5Q671-390 700-390t49.5-20.5Z"
		/>
	</svg>
);
